export const GET_USERS = "GET_USERS";
export const GET_DETAIL_USER = "GET_DETAIL_USER";
export const GET_TYPES_IDENTIFICATION = "GET_TYPES_IDENTIFICATION";
export const GET_IDENTIFICATION_SELECTED = "GET_IDENTIFICATION_SELECTED";
export const GET_GENDERS = "GET_GENDERS";
export const GET_CIVIL_STATUS = "GET_CIVIL_STATUS";
export const GET_TYPES_EPS = "GET_TYPES_EPS";
export const GET_TYPES_AFP = "GET_TYPES_AFP";
export const GET_TYPES_ARL = "GET_TYPES_ARL";
export const GET_TYPES_CCF = "GET_TYPES_CCF";
export const GET_STATE_USER = "GET_STATE_USER";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_USER_DETAIL_FIELDS = "GET_USER_DETAIL_FIELDS";
export const GET_USER_PRODUCT_DETAIL_FIELDS = "GET_USER_PRODUCT_DETAIL_FIELDS"